import React, { PropsWithChildren } from 'react';

type SelectListItemBasicProps = PropsWithChildren<{
  title: string;
}>;

export function SelectListItemBasic({ title, children }: Readonly<SelectListItemBasicProps>) {
  return (
    <li className="select-list__item">
      <div className="select-list__selection">
        <p className="select-list__title">{title}</p>
        {children}
      </div>
    </li>
  );
}
